var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H17V13H19M19 19H17V17H19M13 7H11V5H13M13 11H11V9H13M13 15H11V13H13M13 19H11V17H13M7 11H5V9H7M7 15H5V13H7M7 19H5V17H7M15 11V5L12 2L9 5V7H3V21H21V11H15Z",
    fill: "#184799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCity);
export default __webpack_public_path__ + "static/media/mdi_city.10740dcac90b9e1790f8c255972d9c3f.svg";
export { ForwardRef as ReactComponent };